import apiClient from "../lib/apiClient";
import { getConfiguredSchoolId } from "./schoolConfig";

//==============Get All Classes==================

export const getClasses = async (id = -1, schoolIdOverride) => {
  const configuredSchoolId = await getConfiguredSchoolId();
  const schoolId = schoolIdOverride || configuredSchoolId;

  const res = await apiClient.get(`/Courses/TAGTypes/${id}`, {
    headers: {
      SchoolID: schoolId || "",
    },
  });
  return res.data;
};

//============Get subject by class Id==================

export const getSubjectsByclassId = async (id = -1) => {
  const schoolId = await getConfiguredSchoolId();

  const res = await apiClient.get(`/LiveClasses/GetSubjectsByClass?classId=${id}`, {
    headers: { SchoolID: schoolId || ""},
  });
  return res.data;
};

//=============Get Course by class================

// export const getCoursesByclassId = async (courseTag)=>
// {
//   try{
//     const response = await apiClient.get(`/LiveClasses/GetCoursesByTag?courseTag=${courseTag}`,
    
//     )
//      return response.data;

//   }
//    catch (error) {
//     console.error("Get Courses Error:", error);
//     throw error;
//   }
// }

//=============Get courses by course tag and school================
export const getCoursesByTagAndSchoolId = async (courseTag, schoolId) => {
  try {
    const resolvedSchoolId = schoolId || await getConfiguredSchoolId();

    const response = await apiClient.get(
      `/LiveClasses/GetCoursesByTag1?courseTag=${encodeURIComponent(courseTag)}&schoolId=${encodeURIComponent(resolvedSchoolId || "")}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get school-wise courses error:", error);
    throw error;
  }
};
